const constants = require('@/util/constants')
require('./config')

/**
 * 发送消息
 * 
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function sendMessageLazada(content, successcb, failedcb) {
    axios.post('/api/lazada/sendmessage', {
        content: content,
        client: constants.HTTP_CLIENT
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 消息撤回
 * 
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function messageRecallLazada(sessionId, messageId, successcb, failedcb) {
    axios.post('/api/lazada/messagerecall', {
        sessionId: sessionId,
        messageId: messageId,
        client: constants.HTTP_CLIENT
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}
